<template>
  <div class="block">
    <h2 class="block__title">
      <slot />
    </h2>

    <TransitionGroup
      tag="div"
      name="fade"
      class="category"
    >
      <LabsCategoryCard
        v-for="(card, index) in categories"
        :key="`CategoryCard${index}`"
        :card="card"
      />
    </TransitionGroup>
  </div>
</template>

<script setup lang="ts">
import { LabData } from '@/types/LabData';
import LabsCategoryCard from './CategoryCard.vue';

defineProps<{
  categories: Array<LabData>;
}>();

</script>

<style scoped lang="scss">
@import "@/assets/style/include.scss";

.block {
  gap: 16px;
}

.category {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 16px;
}

@include media-breakpoint-down("notebook") {
  .category {
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  }
}

@include media-breakpoint-down("tablet") {
  .category {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  }
}

@include media-breakpoint-down("mobile") {
  .category {
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  }
}
</style>
